export default [
  {
    title: 'مدیریت مقاله‌ها',
    icon: 'bx bx-chalkboard',
    children: [
      {
        title: 'مقاله‌ها',
        route: { name: 'blog' },
        resource: 'BlogManager',
        action: 'show',
      },
      {
        title: 'دسته‌بندی‌ها',
        route: { name: 'blogcategory' },
        resource: 'BlogCategoryManager',
        action: 'show',
      },
    ],
  },
]
